import { types, actions } from './requests'
export const CREATECOST_TYPES = {
    ...types('CREATECOST'),
}
export const CREATECOST_ACTIONS = {
    ...actions('CREATECOST'),
}
